import React from 'react';
import BuildIcon from '@mui/icons-material/Build';

import { useRouter } from 'common/hooks';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import MenuItemButton from './MenuItemButton';

const AdminDashboardMenuItem: React.FC = () => {
  const { goTo } = useRouter();

  const handleClick = () => {
    goTo(AppRoutesEnum.ADMIN_DASHBOARD_ROOT, {}, { state: { resetHistoryIndex: true } });
  };

  return (
    <MenuItemButton onClick={handleClick} label="Admin Dashboard">
      <BuildIcon />
    </MenuItemButton>
  );
};

export default AdminDashboardMenuItem;
